import * as _ from 'lodash';
import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_ScenarioRow,
    WB_ScenarioPredictorRow, WB_ScenarioSpendRow, WB_ScenarioSpendMethodRow, WB_ModelPredictorRow,
    WB_ScenarioInputRow, WB_ModelInputRow, WB_PeriodRow, WB_FinishedProductRow, WB_ProductGroupRow
} from "../PA.Core/PAdbSchemaRows";
import {IwbScenario} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Scenario,
    esWB_Scenario_Predictor,
    esWB_Scenario_Type,
    esWB_Model,
    esWB_Customer,
    esWB_Product_Group,
    esWB_Period,
    esWB_Scenario_Spend,
    esWB_Scenario_Spend_Method,
    esWB_Scenario_Input,
    esWB_Scenario_MetricDfnR,
    esWB_Scenario_Metric, esWB_Scenario_Type_Input
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {ASync} from "../PA.Core/Basic/ASync";
import {BehaviorSubject} from "rxjs";
import {
    IHaveScenarioInputs,
    IScenario, IScenarioChangedEvent, IHaveScenarioCalculator, IScenarioCalculator
} from "../PA.BusinessModeler.Core/PA.Scenario.IF.Aspects";

import {ProductHierarchyService} from "../PA.MD.Services/ProductHierarchyService";
import {IHaveModel, IHaveModelInputs} from "../PA.Model.Core/PA.Model.IF.Aspects";
import {ModelBO} from "../PA.Model.BusinessObjects/ModelBO";

import {ScenarioCalculator} from "../PA.BusinessModeler.Services/ScenarioCalculator";
import {PeriodService} from "../PA.MD.Services/PeriodService";
import {PAEnvironment} from "../PA.Core/PAEnvironment";



export class ScenarioBO
    implements IBusinessObject,
        IScenario,
        IHaveModel,
        IHaveScenarioInputs,
        IHaveModelInputs,
        IHaveScenarioCalculator {
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_Scenario: WB_ScenarioRow;

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New Business Scenario'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_Scenario = null;

        this.IScenario_init()
        this.IHaveScenarioInputs_init()
        this.IHaveModel_init()
        this.IHaveModelInputs_init()
        this.IHaveScenarioCalculator_init()
    }

    get WB_Scenario(): WB_ScenarioRow {
        return this.drWB_Scenario;
    }

    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        const self = this;
        this.LoadProgressProvider.start("Creating Business Scenario");

        let createOpts = _.defaultsDeep({}, self.CreateOptions, options)

        this._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            self.LoadOptions = options || {};
            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if (this.dbContext == null) {
                let sError = "Unable to determine dbContext for new Business Scenario.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            // Create record using dbContext
            this.dbContext.createRecordWithKey(esWB_Scenario)
                .then((newScenarioRow: WB_ScenarioRow) => {
                    newScenarioRow.setDefaults();
                    self.drWB_Scenario = newScenarioRow;
                    self.dbContext.add(esWB_Scenario, newScenarioRow);
                    self.Identity.setAll(self.WB_Scenario.cif.WB_SCENARIO_ID, self.WB_Scenario.cif.SCENARIO_ID, self.WB_Scenario.cif.SCENARIO_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_Scenario, 'WB_SCENARIO_ID', 'SCENARIO_ID', 'SCENARIO_NAME');

                    self.drWB_Scenario.cif.WB_SCENARIOM_ID = createOpts.ScenarioTypeId
                    self.drWB_Scenario.cif.WB_CUST_ID = createOpts.CustomerId
                    self.drWB_Scenario.cif.WB_PRDGRP_ID = createOpts.ProductId
                    self.drWB_Scenario.cif.WB_PERIOD_ID = createOpts.PeriodId
                    return self.drWB_Scenario.loadRelations([esWB_Customer, esWB_Product_Group, esWB_Period, esWB_Scenario_Type])
                })
                .then((ignore) => {
                    if (self.drWB_Scenario.WB_ScenarioTypeRow) {
                        return self.drWB_Scenario.WB_ScenarioTypeRow.loadRelations([esWB_Model])
                    }
                })
                .then((ignore) => {
                    return self._AfterBoLoadCompleteInternal()
                })
                .then((ignore) => {
                    self.LoadProgressProvider.finish();
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    resolve(self);
                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err);
                    error(err)
                })
        });

        return this._OnLoadComplete;
    }

    Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        const self = this;

        let recordResolver: ESRecordResolver;
        let recordResolverLoadPromise: Promise<void>;

        self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            if (self.bIsLoaded) {
                let sError = "Business Scenario already loaded.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            self.LoadOptions = options || {};

            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else if (self.dbContext == null)
                self.dbContext = new PAdbContext();

            if (this.dbContext == null) {
                let sError = "Unable to determine dbContext for Business Scenario.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            if ('RecordResolver' in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver;
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = ScenarioBO.createRecordResolver({dbContext: self.dbContext});
                recordResolverLoadPromise = ScenarioBO.setupRecordResolver(recordResolver, [anId])
            }

            recordResolverLoadPromise
                .then(function () {
                    let newScenarioRow: any = recordResolver.get(esWB_Scenario, anId);

                    if (_.isEmpty(newScenarioRow)) {
                        self._OnLoadComplete = null;
                        self.LoadProgressProvider.exception("Id not found.");
                        resolve(self);
                        return;
                    }

                    self.drWB_Scenario = newScenarioRow;
                    self.Identity.setAll(self.WB_Scenario.cif.WB_SCENARIO_ID, self.WB_Scenario.cif.SCENARIO_ID, self.WB_Scenario.cif.SCENARIO_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_Scenario, 'WB_SCENARIO_ID', 'SCENARIO_ID', 'SCENARIO_NAME');
                    return self._AfterBoLoadCompleteInternal()
                })
                .then((newScenarioRow: any) => {
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch((err: any) => {
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(err);
                    error(err);
                });

        });

        return this._OnLoadComplete;
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }

    private _AfterBoLoadCompleteInternal(): Promise<void> {
        const self = this;

        return new Promise<void>((resolve, error) => {
            let tasks: Promise<any>[] = [];
            self.LoadProgressProvider.setProgressMessage('ScenarioBO.PostLoad', 'Processing Loaded Data');
            tasks.push(self.OnIHaveModelInputsLoaded)
            tasks.push(self.OnIHaveScenarioInputsLoaded)
            tasks.push(self.IScenario_OnLoadComplete())
            Promise.all(tasks)
                .then((ignore: any) => {
                    return self.OnIHaveModelInputsLoaded
                })
                .then((ignore: any) => {
                    return self.OnIHaveScenarioInputsLoaded
                })
                .then((ignore) => {
                    return self.IHaveScenarioCalculator_OnLoadComplete()
                })
                .then((ignore: any) => {
                    resolve()
                })
                .catch((err: any) => {
                    error(err);
                });
        })
    }

    Reload(opts?: any): Promise<IBusinessObject> {
        const self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            if (!self.bIsLoaded) {
                error("Reload: TPM EventBO not loaded")
                return
            }

            let id = self.WB_Scenario.cif.WB_SCENARIO_ID

            self.dbContext.purgeCache(esWB_Scenario, self.WB_Scenario, {})
                .then((ignore) => {
                    self._bIsLoaded = false
                    self.IScenario_BeforeReload()
                    self.IHaveScenarioCalculator_BeforeReload()

                    return self.Load(id, {dbContext: self.dbContext})
                })
                .then((aBO) => {
                    if (!aBO.bIsLoaded) {
                        console.log("Unable to Load BO in Reload function")
                    }

                    self.OnPredictorInputsCollectionChanged.next(self)
                    self.OnModelInputsChanged.next(self)
                    self.ScenarioCalculator.OnCalculateComplete.next(self.ScenarioCalculator)


                })
                .then((aBO) => {
                    resolve(self)
                })
                .catch((err) => {
                    error(err)
                })
        })

    }

    Validate(options?: any): Promise<IBusinessObject> {

        let self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_Scenario.cif.SCENARIO_NAME + "(" + self.WB_Scenario.cif.SCENARIO_ID + ")");
        return new Promise<IBusinessObject>((resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {};

            if (self.dbContext == undefined) {
                let sError = "Unable to determine dbContext to Validate Business Scenario.";
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
            }

            self._bIsValidated = true;
            self.ValidateProgressProvider.finish();
            resolve(self);
        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }

    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    private SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {

        const self = this;
        const wbScenario = <IwbScenario>self.drWB_Scenario;
        this.SaveProgressProvider.start("Saving " + wbScenario.SCENARIO_NAME + "(" + wbScenario.SCENARIO_ID + ")");

        return new Promise<IBusinessObject>((resolve, reject) => {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // We could search the tree if there is any record where store isn't set.

            if (self.dbContext == null) {
                self._bIsSaved = false;
                let sError = "Unable to determine dbContext to Save Business Scenario.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }

            self.SaveOptions = options || {};

            let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>;
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext);
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext);
            }


            saveFunction(esWB_Scenario, self.drWB_Scenario, {})
                .then((ignore) => {
                    var tasks: Promise<any>[] = []
                    tasks.push(saveFunction(esWB_Scenario, self.drWB_Scenario));
                    tasks.push(saveFunction(esWB_Scenario_Input, self.drWB_Scenario.WB_ScenarioInputRows))
                    tasks.push(saveFunction(esWB_Scenario_Predictor, self.drWB_Scenario.WB_ScenarioPredictorRows))
                    tasks.push(saveFunction(esWB_Scenario_Spend, self.drWB_Scenario.WB_ScenarioSpendRows))
                    tasks.push(saveFunction(esWB_Scenario_MetricDfnR, self.drWB_Scenario.WB_ScenarioMetricDfnRRows))
                    return Promise.all(tasks)
                })
                .then((ignored) => {
                    if (bBatch) {
                        self.dbContext.addBatchCompleteListener(() => {
                            self._bIsSaved = true;
                        })
                    } else {
                        self._bIsSaved = true;
                    }
                    self.SaveProgressProvider.finish();
                    resolve(self);
                })
                .catch((err) => {
                    self.SaveProgressProvider.exception(err);
                    reject(self);
                })
        })
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

    //Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;
        const wbScenario = <IwbScenario>self.drWB_Scenario;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbScenario.SCENARIO_NAME + "(" + wbScenario.SCENARIO_ID + ")");

        return new Promise<IBusinessObject>((resolve, error) => {

            // 1. Validate if we can delete the Business Scenario

            // 2. If Valid, mark all the records for deletion.
            self.drWB_Scenario.markDeleted()
            _.forEach(self.drWB_Scenario.WB_ScenarioPredictorRows, (a) => a.markDeleted())
            _.forEach(self.drWB_Scenario.WB_ScenarioSpendRows, (a) => a.markDeleted())


            if (bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);
                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err);
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }


    //</editor-fold>

    //<editor-fold desc = "IScenario operations">

    _ScenarioPropertyChanged: BehaviorSubject<IScenarioChangedEvent>;

    IScenario_init() {
        this._ScenarioPropertyChanged = new BehaviorSubject<IScenarioChangedEvent>(undefined)
    }

    private IScenario_OnLoadComplete(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            self.WB_Scenario.setupOnChangeEvents([], self.IScenario_onRecordChange.bind(self), self)
            resolve()
        })
    }

    private IScenario_BeforeReload(): void {
        // Do nothing
    }

    private IScenario_onRecordChange(record: WB_ScenarioRow, propertyName: string, propertyValue: any, options: ScenarioBO) {
        this.ScenarioPropertyChanged.next({
            ScenarioBO: options,
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        })
    }

    get ScenarioPropertyChanged(): BehaviorSubject<IScenarioChangedEvent> {
        return this._ScenarioPropertyChanged
    }

    //</editor-fold>

    //<editor-fold desc = "Scenario Spend">

    addScenarioSpend(aWB_SPEND_METHOD_ID: number, options?: any): Promise<ScenarioBO> {
        const self = this;

        return new Promise<ScenarioBO>((resolve, error) => {

            let aScenarioSpendMethodRow: WB_ScenarioSpendMethodRow = undefined

            self.dbContext.find(esWB_Scenario_Spend_Method, aWB_SPEND_METHOD_ID)
                .then((aScenarioSpendMethodRecord: WB_ScenarioSpendMethodRow) => {
                    if (aScenarioSpendMethodRecord == undefined) {
                        // Bad ID
                        resolve(self)
                        return
                    }
                    aScenarioSpendMethodRow = aScenarioSpendMethodRecord
                    // create new records
                    return self.dbContext.createRecordWithKey(esWB_Scenario_Spend)
                })
                .then((aNewRow: WB_ScenarioSpendRow) => {
                    aNewRow.setDefaults()
                    aNewRow.cif.WB_SCENARIO_ID = self.drWB_Scenario.cif.WB_SCENARIO_ID
                    aNewRow.cif.WB_SCENARIO_SPEND_METHOD_ID = aWB_SPEND_METHOD_ID

                    aNewRow.WB_ScenarioSpendMethodRow = aScenarioSpendMethodRow
                    aNewRow.WB_ScenarioRow = self.drWB_Scenario

                    self.dbContext.add(esWB_Scenario_Spend, aNewRow)
                    resolve(self)

                })
                .catch((err) => {
                    error(err)
                })

        })
    }

    removeScenarioSpend(aWB_SCENARIO_SPEND_ID: number, options?: any): Promise<ScenarioBO> {

        const self = this

        return new Promise<ScenarioBO>((resolve, error) => {

            _.forEach(self.drWB_Scenario.WB_ScenarioSpendRows, (aScenarioSpendRow: WB_ScenarioSpendRow) => {
                if (aScenarioSpendRow.isActive && aScenarioSpendRow.cif.WB_SCENARIO_SPEND_ID == aWB_SCENARIO_SPEND_ID) {
                    aScenarioSpendRow.markDeleted()
                }
            })

            resolve(self)
        })

    }

//</editor-fold">

    //<editor-fold desc="IHaveModel Operations">

    private _Model: ModelBO;
    private _OnIHaveModelLoaded: Promise<void>;
    private _bIHaveModelLoaded: boolean;

    IHaveModel_init() {
        this._bIHaveModelLoaded = false
        this._OnIHaveModelLoaded = undefined
        this._Model = undefined
    }

    get bIHaveModelLoaded(): boolean {
        return this._bIHaveModelLoaded
    }

    get OnIHaveModelLoaded(): Promise<void> {
        const self = this

        if (this._OnIHaveModelLoaded) {
            return this._OnIHaveModelLoaded
        }

        let returnValue = new Promise<void>((resolve, error) => {
            let wbModelId = self.WB_Scenario.WB_ScenarioTypeRow.cif.WB_MODEL_ID
            if (!(wbModelId > 0)) {
                resolve()
                return
            }
            let aModel = new ModelBO()
            aModel.Load(wbModelId, {dbContext: self.dbContext})
                .then((ignore) => {
                    self._Model = aModel
                    self._bIHaveModelLoaded = true
                    resolve()
                })
                .catch((err) => {
                    resolve()
                })

        })
        this._OnIHaveModelLoaded = returnValue

        return returnValue
    }

    get Model(): ModelBO {
        return this._Model
    }

    //</editor-fold>

    //<editor-fold desc="IHaveScenarioInputs" operations>

    private _bIHaveScenarioInputsLoaded: boolean
    private _OnIHaveScenarioInputsLoaded: Promise<void>
    private _ScenarioInputsProgressProvider: ProgressProvider
    private _OnPredictorInputsCollectionChanged: BehaviorSubject<IHaveScenarioInputs> = undefined
    private _ScenarioInputs_Periods: WB_PeriodRow[];
    private _ScenarioInputs_ProductGroups: WB_ProductGroupRow[];
    private _ScenarioInputs_Products: WB_FinishedProductRow[];

    IHaveScenarioInputs_init() {
        this._bIHaveScenarioInputsLoaded = false
        this._OnPredictorInputsCollectionChanged = new BehaviorSubject<IHaveScenarioInputs>(this)
        this._ScenarioInputsProgressProvider = new ProgressProvider()
        this._ScenarioInputs_Periods = [];
        this._ScenarioInputs_ProductGroups = [];
        this._ScenarioInputs_Products = [];
    }


    get bIHaveScenarioInputsLoaded(): boolean {
        return this._bIHaveScenarioInputsLoaded
    }

    get OnIHaveScenarioInputsLoaded(): Promise<void> {
        const self = this

        if (self._bIHaveScenarioInputsLoaded) {
            return ASync.resolve()
        }

        if (!_.isEmpty(self._OnIHaveScenarioInputsLoaded)) {
            return self._OnIHaveScenarioInputsLoaded
        }

        let returnValue = new Promise<void>((resolve, error) => {
            let bDone = false
            // Load Periods  (( Update for Phase 2)))
            let scenarioPeriod = undefined
            self.dbContext.find(esWB_Period, self.WB_Scenario.cif.WB_PERIOD_ID)
                .then((wbPeriodRow: WB_PeriodRow) => {
                    scenarioPeriod = wbPeriodRow
                    if (_.isEmpty(wbPeriodRow)) {
                        error("Unable to find Periods for Scenario")
                        bDone = true
                        return
                    }
                    let aModelRow = self.WB_Scenario.WB_ScenarioTypeRow.WB_ModelRow
                    if (_.isEmpty(aModelRow))
                        return
                    let wbPeriodHId = aModelRow.cif.WB_PERIODH_ID
                    let wbPeriodMId = aModelRow.cif.WB_PERIODM_ID
                    if (wbPeriodRow.cif.WB_PERIODM_ID == wbPeriodMId)
                        return [wbPeriodRow]
                    else
                        return PeriodService.getAllChildrenByWBIDChildTypeWbId(wbPeriodMId, wbPeriodRow.cif.WB_PERIOD_ID)
                })
              .then((results) => {
                  if (bDone) { return }
                  return self.dbContext.findUsingCache(esWB_Period, _.map(results, (a) => a.cif.WB_PERIOD_ID))
              })
              .then((results: WB_PeriodRow[]) => {
                  if (bDone) { return }
                  self._ScenarioInputs_Periods = results || []

                    // Load Product Groups  (( Update for Phase 2)))
                    let modelRow = self.WB_Scenario.WB_ScenarioTypeRow.WB_ModelRow
                    if (_.isEmpty(modelRow))
                        return
                    let wbPrdHId = modelRow.cif.WB_PRDH_ID
                    return ProductHierarchyService.getChildrenByPeriodWbID(wbPrdHId, self.WB_Scenario.cif.WB_PRDGRP_ID, self.WB_Scenario.cif.WB_PERIOD_ID, modelRow.cif.PRODUCT_LEVEL)
                })
                .then((arrWbPrdGrps) => {
                    if (bDone) { return }

                    // Loader Product Groups
                    return self.dbContext.findUsingCache(esWB_Product_Group, arrWbPrdGrps)
                })
                .then((arrWbPrdGrpRows) => {
                    if (bDone) { return }
                    self._ScenarioInputs_ProductGroups = <any>arrWbPrdGrpRows || []
                    self._bIHaveScenarioInputsLoaded = true
                    return self.PredictorInputs_sync()
                })
                .then((ignore) => {
                    if (bDone) { return }
                    self._OnIHaveScenarioInputsLoaded = undefined
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })

        self._OnIHaveScenarioInputsLoaded = returnValue
        return returnValue
    }


    get OnPredictorInputsCollectionChanged(): BehaviorSubject<IHaveScenarioInputs> {
        return this._OnPredictorInputsCollectionChanged
    }

    get ScenarioInputs(): WB_ScenarioInputRow[] {
        return this.WB_Scenario.WB_ScenarioPredictorRows
    }

    get ScenarioPredictors(): WB_ScenarioPredictorRow[] {
        return this.WB_Scenario.WB_ScenarioPredictorRows
    }

    get ScenarioInputsProgressProvider(): IProgressProvider {
        return this._ScenarioInputsProgressProvider
    }

    get ScenarioInputs_ProductGroups(): WB_ProductGroupRow[] {
        return this._ScenarioInputs_ProductGroups
    }

    get ScenarioInputs_Products(): WB_FinishedProductRow[] {
        return this._ScenarioInputs_Products
    }

    get ScenarioInputs_Periods(): WB_PeriodRow[] {
        return this._ScenarioInputs_Periods
    }

    async PredictorInputs_sync(): Promise<void> {
        const self = this

        let bRemoveExtra = true
        let dctPrdGrps = _.keyBy(self.ScenarioInputs_ProductGroups, (a) => a.cif.WB_PRDGRP_ID)
        let dctPeriods = _.keyBy(self.ScenarioInputs_Periods, (a) => a.cif.WB_PERIOD_ID)

        // Create Dictionary of Predictor Rows.. remove duplicates, outliers
        let dctPredictors: { [wbPrdGrpId: number]: { [wbPeriodId: number]: WB_ScenarioPredictorRow } } = {}
        _.forEach(self.WB_Scenario.WB_ScenarioPredictorRows, (aRow) => {
            if (!aRow.isActive) {
                return
            }
            let wbPrdGrpId = aRow.cif.WB_PRDGRP_ID
            let wbPeriodId = aRow.cif.WB_PERIOD_ID

            if (!(wbPrdGrpId in dctPrdGrps)) {
                if (bRemoveExtra) {
                    aRow.markDeleted()
                }
                return // continue processig next _forEach row
            }

            if (!(wbPeriodId in dctPeriods)) {
                if (bRemoveExtra) {
                    aRow.markDeleted()
                }
                return // continue processig next _forEach row
            }

            // Place in dictionary to find duplicates
            if (!(wbPrdGrpId in dctPredictors)) {
                dctPredictors[wbPrdGrpId] = {}
            }

            let subDict = dctPredictors[wbPrdGrpId]
            if (!(wbPeriodId in subDict)) {
                subDict[wbPeriodId] = aRow
            } else {
                // Remove duplicate
                aRow.markDeleted()
            }

        })
        // Add missing Predictor Records
        for (let aPeriod of self.ScenarioInputs_Periods) {
            for (let aPrdGrp of self.ScenarioInputs_ProductGroups) {
                let wbPrdGrpId = aPrdGrp.cif.WB_PRDGRP_ID
                let wbPeriodId = aPeriod.cif.WB_PERIOD_ID

                // Insert/ Create Record as needed
                if (!(wbPrdGrpId in dctPredictors)) {
                    dctPredictors[wbPrdGrpId] = {}
                }
                let subDict = dctPredictors[wbPrdGrpId]
                if (!(wbPeriodId in subDict)) {
                    // Create missing RowRecord
                    let newRow: WB_ScenarioPredictorRow = <any>await self.dbContext.createRecordWithKey(esWB_Scenario_Predictor)
                    newRow.setDefaults()
                    newRow.cif.WB_SCENARIO_ID = self.WB_Scenario.cif.WB_SCENARIO_ID
                    newRow.WB_ScenarioRow = self.WB_Scenario
                    newRow.cif.WB_PRDGRP_ID = wbPrdGrpId
                    newRow.cif.WB_PERIOD_ID = wbPeriodId
                    newRow.WB_ProductGroupRow = aPrdGrp
                    newRow.WB_PeriodRow = aPeriod
                    self.dbContext.add(esWB_Scenario_Predictor, newRow)

                    subDict[wbPeriodId] = newRow
                }
            }
        }

        // Create Dictionary of Inut Rows.. remove duplicates, outliers
        let dctInputs: { [wbPrdGrpId: number]: { [wbPeriodId: number]: WB_ScenarioInputRow } } = {}
        _.forEach(self.WB_Scenario.WB_ScenarioInputRows, (aRow) => {
            if (!aRow.isActive) {
                return
            }
            let wbPrdGrpId = aRow.cif.WB_PRDGRP_ID
            let wbPeriodId = aRow.cif.WB_PERIOD_ID

            if (!(wbPrdGrpId in dctPrdGrps)) {
                if (bRemoveExtra) {
                    aRow.markDeleted()
                }
                return // continue processig next _forEach row
            }

            if (!(wbPeriodId in dctPeriods)) {
                if (bRemoveExtra) {
                    aRow.markDeleted()
                }
                return // continue processig next _forEach row
            }

            // Place in dictionary to find duplicates
            if (!(wbPrdGrpId in dctInputs)) {
                dctInputs[wbPrdGrpId] = {}
            }

            let subDict = dctInputs[wbPrdGrpId]
            if (!(wbPeriodId in subDict)) {
                subDict[wbPeriodId] = aRow
            } else {
                // Remove duplicate
                aRow.markDeleted()
            }

        })
        // Add missing Predictor Records
        for (let aPeriod of self.ScenarioInputs_Periods) {
            for (let aPrdGrp of self.ScenarioInputs_ProductGroups) {
                let wbPrdGrpId = aPrdGrp.cif.WB_PRDGRP_ID
                let wbPeriodId = aPeriod.cif.WB_PERIOD_ID

                // Insert/ Create Record as needed
                if (!(wbPrdGrpId in dctInputs)) {
                    dctInputs[wbPrdGrpId] = {}
                }
                let subDict = dctInputs[wbPrdGrpId]
                if (!(wbPeriodId in subDict)) {
                    // Create missing RowRecord
                    let newRow: WB_ScenarioInputRow = <any>await self.dbContext.createRecordWithKey(esWB_Scenario_Input)
                    newRow.setDefaults()
                    newRow.cif.WB_SCENARIO_ID = self.WB_Scenario.cif.WB_SCENARIO_ID
                    newRow.WB_ScenarioRow = self.WB_Scenario
                    newRow.cif.WB_PRDGRP_ID = wbPrdGrpId
                    newRow.WB_ProductGroupRow = aPrdGrp
                    newRow.cif.WB_PERIOD_ID = wbPeriodId
                    newRow.WB_PeriodRow = aPeriod
                    self.dbContext.add(esWB_Scenario_Input, newRow)

                    subDict[wbPeriodId] = newRow
                }
            }
        }

        self.OnPredictorInputsCollectionChanged.next(self)

    }

    //</editor-fold>


    //<editor-fold desc = "IHaveModelInputs">

    private _bIHaveModelInputsLoaded: boolean;
    private _OnIHaveModelInputsLoaded: Promise<void>;
    private _ModelInputs: WB_ModelInputRow[];
    private _ModelInputUIOptions: { [p: number]: { UIGroupName: string; ItemSortOrder: number } };
    private _OnModelInputsChanged: BehaviorSubject<IHaveModelInputs>;

    private IHaveModelInputs_init() {
        this._bIHaveModelInputsLoaded = false
        this._OnIHaveModelInputsLoaded = undefined
        this._ModelInputs = []
        this._ModelInputUIOptions = {}
        this._OnModelInputsChanged = new BehaviorSubject<IHaveModelInputs>(this)
    }

    get bIHaveModelInputsLoaded(): boolean {
        return this._bIHaveModelInputsLoaded
    }

    get OnIHaveModelInputsLoaded(): Promise<void> {
        const self = this
        if (self._bIHaveModelInputsLoaded)
            return ASync.resolve()

        if (!_.isEmpty(self._OnIHaveModelInputsLoaded)) {
            return self._OnIHaveModelInputsLoaded
        }

        let returnValue = new Promise<void>((resolve, error) => {
            let dctUIOptions: typeof self._ModelInputUIOptions = {}
            let dctInputs: { [id: number]: WB_ModelInputRow } = {}
            _.forEach(self.WB_Scenario.WB_ScenarioTypeRow.WB_ScenarioTypeInputRows, (aRow) => {

                if (aRow.WB_ModelInputRow) {
                    dctInputs[aRow.WB_ModelInputRow.cif.WB_MODEL_INPUT_ID] = aRow.WB_ModelInputRow
                    dctUIOptions[aRow.WB_ModelInputRow.cif.WB_MODEL_INPUT_ID] = {
                        UIGroupName: aRow.cif.UI_GROUP_NAME,
                        ItemSortOrder: aRow.cif.ITEM_SORT_ORDER
                    }
                }
            })

            self._ModelInputUIOptions = dctUIOptions
            self._ModelInputs = _.values(dctInputs)
            self._bIHaveModelInputsLoaded = true
            self._OnIHaveModelInputsLoaded = undefined
            resolve()
        })

        this._OnIHaveModelInputsLoaded = returnValue
        return returnValue
    }

    get ModelInputs(): WB_ModelInputRow[] {
        return this._ModelInputs
    }

    get ModelInputUIOptions(): { [p: number]: { UIGroupName: string; ItemSortOrder: number } } {
        return this._ModelInputUIOptions
    }

    get OnModelInputsChanged(): BehaviorSubject<IHaveModelInputs> {
        return this._OnModelInputsChanged
    }

    //</editor-fold>


    //<editor-fold desc = "RecordResolver Static Methods">

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {};
        let dbContext: PAdbContext;

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }

        const model_options: CreateOptions = {
            standardConditions: {
                [esWB_Scenario_Predictor]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Scenario_Input]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Scenario_Spend]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Scenario_Type_Input]: {"DELETED_IND": {"notIn": ['1']}},
            },
            dctIncludeBelongsToNamedRelations: {
                [esWB_Scenario_Type]: [esWB_Model, esWB_Scenario_Type_Input]
            },
            dctExcludeHasManyNamedRelations: {
                [esWB_Scenario]: [esWB_Scenario_Metric]
            }
        };

        const aRecResolver = new ESRecordResolver(dbContext, model_options);

        return aRecResolver;
    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_Scenario, ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

    //</editor-fold>


    //<editor-fold desc="IHaveScenarioCalculator operations">

    private _ScenarioCalculator: IScenarioCalculator;

    private IHaveScenarioCalculator_init() {
        this._ScenarioCalculator = new ScenarioCalculator()
    }

    private IHaveScenarioCalculator_OnLoadComplete(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            self._ScenarioCalculator.Register(self)
            resolve()
        })

    }

    private IHaveScenarioCalculator_BeforeReload(): void {
        // Do nothing
    }

    get ScenarioCalculator(): IScenarioCalculator {
        return this._ScenarioCalculator
    }


    //</editor-fold>

};
PAEnvironment.registerBusinessObjectClass(ScenarioBO, "ScenarioBO", "Scenario")